
import React from 'react';
import { UserProfile } from "@/types";
import { useAuth } from "@/context/AuthContext";
import PageHeaderContainer from '../layout/PageHeaderContainer';

interface DashboardHeaderProps {
  isLoading: boolean;
  userProfile: UserProfile | null;
}

const DashboardHeader = ({ isLoading, userProfile }: DashboardHeaderProps) => {
  const { user } = useAuth();
  
  // Get a greeting based on the time of day
  const getTimeBasedGreeting = () => {
    const currentHour = new Date().getHours();
    
    if (currentHour < 12) {
      return "Good morning";
    } else if (currentHour < 18) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };

  // Extract first name from full name, checking both profile and auth user data
  const getFirstName = () => {
    // First try to get name from user_metadata as it's more up-to-date
    const metadataName = user?.user_metadata?.name;
    
    if (metadataName) {
      return metadataName.split(' ')[0];
    }
    
    // Fall back to userProfile if metadata name is not available
    if (userProfile?.name) {
      return userProfile.name.split(' ')[0];
    }
    
    // Last resort fallback
    return "User";
  };

  return (
    <PageHeaderContainer>
      <div>
        {isLoading ? (
          <div className="h-8 bg-gray-200 animate-pulse rounded w-64 mb-1"></div>
        ) : (
          <h1 className="text-3xl font-bold tracking-tight mb-1 flex items-center gap-2">
            {getTimeBasedGreeting()}, {getFirstName()} 👋
          </h1>
        )}
        <p className="text-muted-foreground">
          Manage your investor forms and leads
        </p>
      </div>
    </PageHeaderContainer>
  );
};

export default DashboardHeader;
